import Container from "./styles";
import Line from "../../../../assets/Line.png";
import pointer from "../../../../assets/pointer.png";
import { useDispatch } from "react-redux";
import { altzoneData } from '../../../../store/actions'
import { useNavigate } from "react-router-dom";

export default function Places({item, id}) {

  const dispatch = useDispatch()
  const navigate = useNavigate();

  return (
    <Container>
      <div className="Place__Card" key={id}>
        <div className="Place__head">
          <div className="Place__sign">Zone name</div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: 50,
            }}
          >
            <div className="Place_icon"   onClick={() => navigate('/dashboard/zone/update', {state: {state: item}} )}>
              <svg
                width="10"
                height="9"
                viewBox="0 0 10 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.66304 1.61475L4.32576 1.69546C4.16596 1.84837 4.00795 2.00132 3.84815 2.15423L3.29707 2.68331L1.144 2.63587L1.02979 7.81904L6.21295 7.93325L6.26044 5.77839C6.60392 5.44972 6.94741 5.12104 7.29089 4.79237L7.2101 8.45869C7.20396 8.73726 6.97253 8.95872 6.69396 8.95258L0.50435 8.81618C0.225782 8.81005 0.00432319 8.57861 0.0104616 8.30004L0.146934 2.10684C0.153072 1.82827 0.384471 1.60861 0.66304 1.61475ZM8.87949 1.48833C8.93071 1.61173 8.94204 1.75043 8.9733 1.88238C8.96201 1.98642 8.92429 2.0665 8.84902 2.13677C7.32817 3.59027 5.80733 5.04378 4.2882 6.50092C4.22942 6.55716 4.1658 6.58812 4.08817 6.6026C3.44359 6.72325 2.79902 6.8439 2.1544 6.96635C2.00272 6.99538 1.89199 6.87965 1.92767 6.7294C2.07851 6.08541 2.22756 5.44139 2.38376 4.79932C2.39952 4.73673 2.43873 4.67107 2.48469 4.62533C2.92014 4.20338 3.35909 3.78511 3.79626 3.3668C4.87814 2.33157 5.96003 1.29633 7.04016 0.259263C7.11918 0.181888 7.20632 0.144251 7.31028 0.159128C7.42858 0.17612 7.55231 0.191433 7.66095 0.238779C8.23626 0.487006 8.64047 0.911271 8.87949 1.48833ZM3.87962 6.19343C3.85296 6.09754 3.83904 5.99475 3.79422 5.90745C3.6201 5.56737 3.36521 5.30283 3.0257 5.12453C2.92972 5.07387 2.82795 5.04106 2.7091 5.04923C2.64561 5.31934 2.58048 5.58222 2.5225 5.84706L2.52246 5.84886C2.80355 5.9036 3.02337 6.12781 3.07291 6.40941C3.32383 6.36459 3.57307 6.31434 3.824 6.26952C3.87272 6.26161 3.89121 6.23864 3.87962 6.19343Z"
                  fill="#2F59C8"
                />
              </svg>
            </div>
            <div className="Place_icon" onClick={()=>dispatch(altzoneData({...item}, 'delete'))}>
              <svg
                width="7"
                height="9"
                viewBox="0 0 7 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.52827 2.37782L6.33198 1.78955C6.29246 1.67115 6.18165 1.59131 6.05683 1.59131H0.94117C0.816347 1.59131 0.705535 1.67117 0.666019 1.78955L0.469724 2.37782C0.425252 2.5111 0.524445 2.64877 0.664947 2.64877H6.33303C6.47355 2.64877 6.57274 2.5111 6.52827 2.37782Z"
                  fill="#DB3333"
                />
                <path
                  d="M1.38298 8.64442C1.40548 8.8469 1.57662 9.00008 1.78035 9.00008H5.18555C5.38928 9.00008 5.56042 8.84688 5.58292 8.64442L6.19051 3.17627H0.775391L1.38298 8.64442Z"
                  fill="#DB3333"
                />
                <path
                  d="M2.96875 0.755824C2.96875 0.629842 3.07125 0.527344 3.19723 0.527344H3.97399C4.09997 0.527344 4.20247 0.629842 4.20247 0.755824V1.06402H4.72981V0.755824C4.72981 0.339064 4.39075 0 3.97399 0H3.19723C2.78047 0 2.44141 0.339064 2.44141 0.755824V1.06402H2.96875V0.755824Z"
                  fill="#DB3333"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className="Place__id">{item.name}</div>
        <div className="Place_state">State</div>
        <div className="Place">{item.state} State</div>
        <img src={Line} alt="Line" />
        <div className="pickup__location">
          <img src={pointer} alt="pointer" />
          <div className="pickup__container">
            <div className="pickup__title">Pick up location</div>
            <div className="pickup__place">{new Intl.ListFormat().format(item.cities)}</div>
          </div>
        </div>
        <img src={Line} alt="Line" style={{ marginTop: -50 }} />
        <table style={{width:"100%", marginTop:-20}}>
          <tr>
            <td style={{textAlign:"left"}}>
              <div>Price/Mile</div>
              <div>₦ {item.amount}</div>
            </td>

            <td style={{textAlign:"right"}}>
              <div>Operational cost</div>
              <div>₦ {item.operation_cost}</div>
            </td>
          </tr>
        </table>
      </div>
    </Container>
  );
}
